import { api } from "@/api";

export default {
  fetchCoBrokering(groupId, creditLimitId) {
    return api.get(`/v1/gruposeconomicos/${groupId}/limitescredito/${creditLimitId}/cocorretagem`);
  },
  listEconomicGroups(filter) {
    return api.get(`/v1/gruposeconomicos`, {
      params: filter
    });
  },
  listCompanies(groupId, filter) {
    return api.get(`/v1/gruposeconomicos/${groupId}/tomadores`, {
      params: filter
    });
  },
  findEconomicGroup(groupId) {
    return api.get(`/v1/gruposeconomicos/${groupId}`);
  },
  findCompany(groupId, companyId) {
    return api.get(`/v1/gruposeconomicos/${groupId}/tomadores/${companyId}`);
  },
  findCreditLimitConsult(groupId, consultId) {
    return api.get(
      `/v1/gruposeconomicos/${groupId}/limitescredito/${consultId}`
    );
  },
  createEconomicGroup(economicGroup) {
    return api.post("/v1/gruposeconomicos", economicGroup);
  },
  createCompany(groupId, company) {
    return api.post(`/v1/gruposeconomicos/${groupId}/tomadores`, company);
  },
  createCreditLimitConsult(groupId, consult) {
    return api.post(
      `/v1/gruposeconomicos/${groupId}/limitescredito/consultarmercado`,
      consult
    );
  },
  uploadLogo(payload) {
    return api.post("/arquivos/upload", payload);
  },
  updateEconomicGroup(groupId, economicGroup) {
    return api.put(`/v1/gruposeconomicos/${groupId}`, economicGroup);
  },
  updateCompany(groupId, companyId, company) {
    return api.put(
      `/v1/gruposeconomicos/${groupId}/tomadores/${companyId}`,
      company
    );
  },
  listQuotationsByInsurer(filter) {
    return api.get(
      `/v1/gruposeconomicos/limitescredito/acompanharseguradoras`,
      {
        params: filter
      }
    );
  },
  creditLimitStatuses() {
    return api.get(`/v1/gruposeconomicos/limitescredito/status/suggest`);
  },
  listQuotationsOfEconomicGroup(groupId, filter) {
    return api.get(`/v1/gruposeconomicos/${groupId}/limitescredito`, {
      params: filter
    });
  },
  balanceDocumentsOfEconomicGroup(groupId) {
    return api.get(
      `/v1/gruposeconomicos/${groupId}/documentos/balancos/suggest`
    );
  },
  otherDocumentsOfEconomicGroup(groupId) {
    return api.get(`/v1/gruposeconomicos/${groupId}/documentos/outros/suggest`);
  },
  updateCreditLimit(groupId, consultId, payload) {
    return api.put(
      `/v1/gruposeconomicos/${groupId}/limitescredito/${consultId}`,
      payload
    );
  },
  getRelationshipContacts(payload) {
    return api.get(`/v1/seguradoras/${payload}/contatosrelacionamento/suggest`);
  },
  getStrutureCCG() {
    return api.get(`/v1/gruposeconomicos/limitescredito/estruturaccg/suggest`);
  },
  getApprovalRules() {
    return api.get(
      `/v1/gruposeconomicos/limitescredito/tiposregrasaprovacao/suggest`
    );
  },
  getPrizeRules() {
    return api.get(
      `/v1/gruposeconomicos/limitescredito/tiposregraspremio/suggest`
    );
  },
  getModalityAccordingInsurance(payload) {
    return api.get(`/v1/seguradoras/${payload}/modalidades/suggest`);
  },
  getCompaniesAccordingEconomicGroup(payload) {
    return api.get(`/v1/gruposeconomicos/${payload}/tomadores/suggest`);
  },
  getHistoricLimit(groupId, insurance) {
    return api.get(
      `/v1/gruposeconomicos/${groupId}/limitescredito/historico?seguradora_id=${insurance}`
    );
  },
  renewCreditLimit(groupId, consultId, payload) {
    return api.post(
      `/v1/gruposeconomicos/${groupId}/limitescredito/${consultId}/renovar`,
      payload
    );
  },
  getInsuranceConsultMarket(payload) {
    return api.get("/v1/seguradoras/suggest/consultamercado", {
      params: payload
    });
  },
  getOffices() {
    return api.get("/v1/escritorios/suggest");
  }
};
